import { render } from "./Empresas.vue?vue&type=template&id=be5c67b8&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
script.render = render

export default script